function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _objectSpread({
        width: "31",
        height: "31",
        viewBox: "0 0 31 31"
    }, props, {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M9.92 23.25L15.5 17.67L21.08 23.25L23.25 21.08L17.67 15.5L23.25 9.92L21.08 7.75L15.5 13.33L9.92 7.75L7.75 9.92L13.33 15.5L7.75 21.08L9.92 23.25ZM15.5 31C13.3558 31 11.3408 30.5929 9.455 29.7786C7.56917 28.9654 5.92875 27.8612 4.53375 26.4662C3.13875 25.0712 2.03463 23.4308 1.2214 21.545C0.407133 19.6592 0 17.6442 0 15.5C0 13.3558 0.407133 11.3408 1.2214 9.455C2.03463 7.56917 3.13875 5.92875 4.53375 4.53375C5.92875 3.13875 7.56917 2.03412 9.455 1.21985C11.3408 0.406617 13.3558 0 15.5 0C17.6442 0 19.6592 0.406617 21.545 1.21985C23.4308 2.03412 25.0712 3.13875 26.4662 4.53375C27.8612 5.92875 28.9654 7.56917 29.7786 9.455C30.5929 11.3408 31 13.3558 31 15.5C31 17.6442 30.5929 19.6592 29.7786 21.545C28.9654 23.4308 27.8612 25.0712 26.4662 26.4662C25.0712 27.8612 23.4308 28.9654 21.545 29.7786C19.6592 30.5929 17.6442 31 15.5 31Z",
            fill: "#D93333"
        })
    }));
};
export default Icon;
